import React from 'react';
import './ErrorBanner.scss';

interface ErrorBannerProps {
  message: string;
  className?: string;
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({ message, className }) => {
  if (!message) return null;

  return (
    <div className={`error-banner${className ? ` ${className}` : ''}`} role="alert">
      {message}
    </div>
  );
};

export default ErrorBanner;
